/**
 * Blindaje contra extensiones/servicios que mutan el DOM por fuera de React
 * (Google Translate, la traducción integrada de Chrome, algunos gestores de
 * contraseñas, etc.).
 *
 * Cuando Translate reemplaza un nodo de texto por una copia envuelta en
 * <font>...</font>, el árbol real deja de coincidir con el que React tiene en
 * memoria. En el siguiente re-render, React llama `removeChild` / `insertBefore`
 * sobre un nodo que ya no está donde cree, y el navegador lanza:
 *
 *   NotFoundError: Failed to execute 'removeChild' on 'Node':
 *   The node to be removed is not a child of this node.
 *
 * Esto deja la app en pantalla blanca. El parche hace que esas dos operaciones
 * degraden de forma silenciosa en vez de lanzar, siguiendo el workaround
 * documentado en https://github.com/facebook/react/issues/11538.
 *
 * Importar este módulo por su efecto secundario ANTES de montar React.
 */

if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.call(this, child) as T;
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      return this.appendChild(newNode);
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T;
  };
}
